import { Dict } from "mixpanel-browser";

export enum MixpanelEventName {
  userDirectlyLoggedinAccountsApp = "User Signed in directly in accounts app",
  satelliteAppUserLoggedInThroughAccountsAppAndNavigatedBackToSateliteApp = "Satellite app User logged in through accounts app and navigated back to satelite app",
  noRedirectUrlFound = "User logged into accounts app, navigating user to dashboard page",
  rolesUpdatedForUser = "Roles updated for user",
  noNeededToUpdateRolesForUser = "Roles not updated as it is existing user for the same satellite app",
  userClickedSideBarMenuItem = "User clicked on Menu in Sidebar",
  userClickedonButtonFromDashboardPage = "User clicked on Button from Dashboard page",
}

export type CustomEventProps = {
  mixpanelProps: Dict;
  id: string | number;
  eventName: MixpanelEventName;
  propertyName?: string;
};
